import React from 'react';
import { TtsGenderFab } from './TtsGenderFab';
import { TtsVoiceFab } from './TtsVoiceButton';
export const TtsSelector = ({ showVoices, closeMenu, buttonPopupMenu, isToggle, shouldStopAudio }) => {
    return !showVoices ? (React.createElement(TtsGenderFab, { menu: true, buttonPopupMenu: buttonPopupMenu })) : (React.createElement(TtsVoiceFab, { shouldStopAudio: shouldStopAudio, isToggle: isToggle, closeMenu: closeMenu, buttonPopupMenu: buttonPopupMenu }));
};
